import { usePreviousValue } from "PFCore/hooks/use_previous_value";
import { OrderOption } from "PFTypes";

import { WorkOpportunitiesTab } from "../../constants";
import { OrderData } from "../../contexts/marketplace_context.types";
import { getTabOrder } from "../../helpers/get_tab_order";

export const usePreviousOrder = (orderData: OrderData): OrderOption | null => {
  const matchingRolesPreviousOrder = usePreviousValue(
    getTabOrder(orderData, WorkOpportunitiesTab.MatchingRoles)
  );
  const interestedPreviousOrder = usePreviousValue(getTabOrder(orderData, WorkOpportunitiesTab.Interested));
  const savedRolesPreviousOrder = usePreviousValue(getTabOrder(orderData, WorkOpportunitiesTab.SavedRoles));
  const sharedRolesPreviousOrder = usePreviousValue(
    getTabOrder(orderData, WorkOpportunitiesTab.SharedWithMe)
  );

  const tabToPreviousOrderMap = {
    [WorkOpportunitiesTab.MatchingRoles]: matchingRolesPreviousOrder,
    [WorkOpportunitiesTab.Interested]: interestedPreviousOrder,
    [WorkOpportunitiesTab.SavedRoles]: savedRolesPreviousOrder,
    [WorkOpportunitiesTab.SharedWithMe]: sharedRolesPreviousOrder
  };

  return orderData.tab ? tabToPreviousOrderMap[orderData.tab] ?? null : null;
};
